import React from 'react';
import { AlertTriangle, X, Trash2, AlertCircle, Info } from 'lucide-react';
import LatteButton from './LatteButton';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "확인", 
  message, 
  confirmText = "확인", 
  cancelText = "취소",
  type = "default" // "default", "danger", "warning", "info", "success"
}) => {
  if (!isOpen) return null;

  const getButtonVariant = () => {
    switch (type) {
      case 'danger':
        return 'danger';
      case 'warning':
        return 'primary'; // warning은 primary(라떼) 색상 사용
      default:
        return 'primary';
    }
  };



  return (
    <div className="modal-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    }}>
      <div className="modal modal-sm">
        {/* 헤더: 아이콘 + 타이틀 */}
        <div className="flex items-center gap-3 mb-6">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${
            type === 'danger' ? 'bg-red-100' : 
            type === 'warning' ? 'bg-amber-100' : 
            type === 'success' ? 'bg-green-100' : 
            'bg-blue-100'
          }`}>
            {type === 'danger' && <Trash2 className="w-6 h-6 text-red-600" />}
            {type === 'warning' && <AlertCircle className="w-6 h-6 text-amber-600" />}
            {type === 'success' && <AlertCircle className="w-6 h-6 text-green-600" />}
            {(type === 'default' || type === 'info') && <Info className="w-6 h-6 text-blue-600" />}
          </div>
          <h3 className="text-xl font-semibold text-gray-900">
            {title}
          </h3>
        </div>
        
        {/* 메시지 영역 */}
        <div className="text-center">
          <p className="text-gray-600 whitespace-pre-line">
            {message}
          </p>
        </div>
        
        {/* 버튼 영역 */}
        <div className="flex gap-3 mt-8">
          <LatteButton
            onClick={onClose}
            variant="secondary"
            size="lg"
            className="flex-1"
          >
            {cancelText}
          </LatteButton>
          <LatteButton
            onClick={() => {
              onConfirm();
              onClose();
            }}
            variant={getButtonVariant()}
            size="lg"
            className="flex-1"
          >
            {confirmText}
          </LatteButton>
        </div>

        {/* 닫기 버튼 */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <X className="w-5 h-5 text-gray-400" />
        </button>
      </div>
    </div>
  );
};

export default ConfirmationModal;